// This is extracted and refactored from `RxDBHandler` in `src/rxdb/useRxDB.tsx`.
// It is probably no longer necessary with the Replication V2 refactoring.
// As V2 matures & proven to work successfully, consider removing this.
import { useContext, useEffect } from 'react';

import { useFlags } from '@/featureFlags/useFlags';
import { useOnlineStatus } from '@/utilities/index';

import { createGoal } from '../actions/goals/Goal';
import { kind as restart } from '../actions/goals/Restart';
import { dataManagerContext } from '../dataManagerContext';
import { summarize } from '../ReplicationStateSummary';
import { useReplication } from '../useReplication';

export function useSyncCheck() {
  const allowSync = useFlags().msBorerDataSync.allowSync;
  const { dispatch } = useContext(dataManagerContext);
  const replication = useReplication();
  const online = useOnlineStatus();

  useEffect(() => {
    if (replication) {
      const interval = setInterval(async () => {
        const summary = summarize(replication.replicationStates, replication.families);
        if (summary.notOperating.length > 0 && online && allowSync) {
          // Note that this is a "restart", whereas the legacy code just calls `startReplication`.
          // In V2, `restart` is necessary to shut down the (now stopped) replications and restart them.
          dispatch(createGoal(restart));
        }
      }, 15000);

      return () => clearInterval(interval);
    }
  }, [replication, dispatch, online, allowSync]);
}
